import { Link } from 'react-router-dom';
import FadeInSection from '@/components/base/FadeInSection';

export default function AboutPreview() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-100">
      <FadeInSection>
        <div className="w-full px-4 md:px-6 lg:px-10 max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 md:gap-14">
          {/* Image Side */}
          <div className="w-full lg:w-1/2">
            <div className="relative rounded-2xl overflow-hidden">
              <img
                src="/images/home-about-preview.jpg"
                alt="About Bassi Enterprises – fresh produce supply facility in Shamli"
                title="Bassi Enterprises – Fresh Produce Supply Facility"
                className="w-full h-[280px] md:h-[380px] object-cover object-top"
              />
              {/* Stats Badge */}
              <div className="absolute bottom-5 left-5 bg-background-50/95 backdrop-blur-sm rounded-xl px-5 py-3 flex items-center gap-3">
                <div className="w-10 h-10 rounded-lg bg-primary-50 flex items-center justify-center">
                  <i className="ri-award-line text-primary-600 text-lg"></i>
                </div>
                <div>
                  <p className="text-foreground-900 font-bold text-lg leading-tight">3+</p>
                  <p className="text-foreground-500 text-xs">Registrations</p>
                </div>
              </div>
            </div>
          </div>

          {/* Content Side */}
          <div className="w-full lg:w-1/2">
            <span className="inline-block px-4 py-1.5 bg-accent-100 text-accent-800 text-xs font-semibold rounded-full mb-4">
              Our Story
            </span>
            <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 mb-5">
              About <strong className="text-primary-600">Bassi Enterprises</strong>
            </h2>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-5">
              Bassi Enterprises is committed to supplying fresh fruits and vegetables with quality, reliability and competitive pricing. Based in Shamli, Uttar Pradesh, we serve businesses across India through our growing supply chain network.
            </p>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-6">
              Our goal is to become a trusted fresh produce supply partner for businesses requiring regular and bulk quantities. We focus on quality produce, timely availability, and long-term B2B partnerships.
            </p>

            <div className="grid grid-cols-2 gap-3 mb-7">
              {[
                'Quality Produce',
                'Timely Availability',
                'B2B Supply',
                'Long-Term Partnerships',
              ].map((item) => (
                <div key={item} className="flex items-center gap-2.5">
                  <div className="w-5 h-5 rounded-full bg-primary-50 flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-primary-600 text-xs"></i>
                  </div>
                  <span className="text-foreground-700 text-sm font-medium">{item}</span>
                </div>
              ))}
            </div>

            <Link
              to="/about"
              className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 text-sm font-semibold rounded-full hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Learn More About Us
              <i className="ri-arrow-right-line text-lg"></i>
            </Link>
          </div>
        </div>
        </div>
      </FadeInSection>
    </section>
  );
}